import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';

import { Tabs } from '@/components';
import { TourneyList } from '@/components/GenericsTournaments';
import { NotFoundResult } from '@/components/NotFoundResult';
import { DefaultTabsProps } from '@/components/Tabs';
import { TabType } from '@/components/Types';
import { useHandleChangesTabs } from '@/hooks/useHandleChangesTabs';
import { ActionsTourneys, GenericItemTourneysData } from '@/types/tda';
import { EnumContextGDT } from '@/types/team';
import { FADE_IN_OUT, TEXTS } from '@/utils';

type Props = {
  list: GenericItemTourneysData[] | null;
  onSubmitTabSelected: (tab: TabType) => void;
  onHandleSubmit: (({ id, action }: ActionsTourneys) => void) | undefined;
  tabSelected: TabType;
  loadMore?: (pageNumber?: number) => void;
  hasMore?: boolean;
  context?: EnumContextGDT;
  tabs: DefaultTabsProps['tabs'];
  cantidadBusquedas: number;
  withAvatar?: boolean;
  totalCount?: number;
};

export const InscriptionSearchingResult: React.FC<Props> = React.memo(
  ({
    list,
    onSubmitTabSelected,
    onHandleSubmit,
    tabSelected,
    tabs,
    loadMore,
    hasMore,
    cantidadBusquedas,
    withAvatar,
    totalCount,
  }) => {
    const { tab, handleTabChanges } = useHandleChangesTabs();
    const [isClickedOnTab, setIsClickedOnTab] = useState(false);

    useEffect(() => {
      if (list?.length === 0 && !isClickedOnTab) {
        handleTabChanges(TabType.SecondTab);
        onSubmitTabSelected(TabType.SecondTab);
      } else {
        handleTabChanges(tabSelected);
      }
      return () => {
        handleTabChanges(tabSelected);
      };
    }, [handleTabChanges, tabSelected]);

    const onClickTab = (tab: TabType) => {
      handleTabChanges(tab);
      onSubmitTabSelected(tab);
    };

    if (!list) return;

    return (
      <>
        <Tabs
          activeTab={tab}
          className="!h-[34px] !mt-4"
          classNameTabs="!text-xs h-full"
          tabs={tabs}
          variant="underline"
          onClick={(tab: TabType) => {
            setIsClickedOnTab(true);
            onClickTab(tab);
          }}
        />
        <motion.div
          key={tab}
          animate={'show'}
          initial={'hide'}
          variants={FADE_IN_OUT}
        >
          {list.length > 0 && (
            <TourneyList
              paginator
              className="w-[calc(100%+2rem)] relative -left-4 lg:w-full lg:left-0"
              classNameWrapperList="!bg-gdt-gray-6 !space-y-[3px] lg:rounded-none lg:rounded-xl"
              classPaginator="paginator-sidebar"
              handleSubmit={onHandleSubmit}
              hasMore={hasMore}
              list={list}
              loadMore={loadMore}
              totalCount={totalCount}
              withAvatar={withAvatar}
            />
          )}
          {list?.length === 0 && isClickedOnTab && (
            <NotFoundResult title={TEXTS.notFoundResult} />
          )}
          {list?.length === 0 && cantidadBusquedas === 2 && !isClickedOnTab && (
            <NotFoundResult title={TEXTS.notFoundResult} />
          )}
        </motion.div>
      </>
    );
  }
);

InscriptionSearchingResult.displayName = 'InscriptionSearchingResult';
